<template>
	<router-view></router-view>
</template>
<script>
export default {
	name: 'page-diagnosis',
};
</script>



// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnosis.vue